export interface VideoModelInfo {
  id: string;
  name?: string;
  description?: string;
  avgCostPerSecond?: number | null;
  minCostPerSecond?: number | null;
  maxCostPerSecond?: number | null;
  avgLatencyMs?: number | null;
  latencySampleCount?: number;
}

export function formatCostPerSecond(n: number | null | undefined): string {
  if (n == null || !Number.isFinite(n)) return "—";
  if (n < 0.01) return `$${n.toFixed(4)}/s`;
  return `$${n.toFixed(2)}/s`;
}

export function formatLatencyMs(ms: number | null | undefined): string {
  if (ms == null || !Number.isFinite(ms) || ms <= 0) return "—";
  if (ms < 1000) return `${Math.round(ms)}ms`;
  const s = ms / 1000;
  if (s < 60) return `~${s.toFixed(0)}s`;
  const m = Math.floor(s / 60);
  const rem = Math.round(s % 60);
  return `~${m}m${rem ? ` ${rem}s` : ""}`;
}

export function modelOptionLabel(m: VideoModelInfo): string {
  const name = m.name && m.name !== m.id ? m.name : m.id;
  const cost =
    m.minCostPerSecond != null &&
    m.maxCostPerSecond != null &&
    Math.abs(m.maxCostPerSecond - m.minCostPerSecond) > 0.001
      ? `${formatCostPerSecond(m.minCostPerSecond).replace("/s", "")}–${formatCostPerSecond(m.maxCostPerSecond)}`
      : formatCostPerSecond(m.avgCostPerSecond);
  const lat = formatLatencyMs(m.avgLatencyMs);
  return `${name}  ·  ${cost}  ·  ${lat}`;
}
